import {mapActions} from "vuex";
import {shouldReturnCheckingQuantity} from "../../app/helper";

export default {
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            currency_symbol: this.$storeInfo.cur_symb || '$',
        }
    },
    computed: {
        product_url() {
            return `${window.baseURl}/product/${this.item.slug}`;
        }
    },
    mounted() {
        console.log('Cart Item Component mounted.')
    },
    methods: {
        ...mapActions("cart", ["updateToCartItems", "removeFromCartItems"]),
        updateCartItemQuantity(operation, quantity = 1) {
            if (operation === 'plus') {
                this.item.quantity += quantity;
                if (shouldReturnCheckingQuantity(this.item)) {
                    this.item.quantity -= quantity;
                    return;
                }
                this.updateToCartItems(this.item);
            } else if (operation === 'minus' && this.item.quantity > 1) {
                this.item.quantity -= quantity;
                this.updateToCartItems(this.item);
            }
        },
        removeCartItem() {
            this.removeFromCartItems(this.item);
        }
    }
}
